/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_Never_FetchedInputs */

const cs_xml_feed_never_fetched = /** @type {(inputs: Xml_Feed_Never_FetchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím nestaženo`)
};

const en_xml_feed_never_fetched = /** @type {(inputs: Xml_Feed_Never_FetchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not fetched yet`)
};

/**
* | output |
* | --- |
* | "Not fetched yet" |
*
* @param {Xml_Feed_Never_FetchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_never_fetched = /** @type {((inputs?: Xml_Feed_Never_FetchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_Never_FetchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_never_fetched(inputs)
	return cs_xml_feed_never_fetched(inputs)
});